import {Component, signal, ChangeDetectionStrategy} from "@angular/core"
import {BaseInspectorComponent} from "@app/template-editor/components/inspectors/base-inspector/base-inspector.component"
import {InspectorSectionComponent} from "@app/template-editor/components/inspectors/inspector-section/inspector-section.component"
import {SelectionPossibilities, ValueSlotComponent} from "@app/template-editor/components/value-slot/value-slot.component"
import {SunLight, SunLightParameters} from "@cm/template-nodes"

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: "cm-sun-light-inspector",
    templateUrl: "./sun-light-inspector.component.html",
    styleUrl: "./sun-light-inspector.component.scss",
    imports: [InspectorSectionComponent, ValueSlotComponent],
})
export class SunLightInspectorComponent extends BaseInspectorComponent<SunLight> {
    readonly $lightTypePossibilites = signal<SelectionPossibilities<SunLightParameters["lightType"]>>([
        {value: "Corona", name: "Corona"},
        {value: "Blender", name: "Blender"},
    ])
}
